import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const uploadCustomFunctionFile = async ({ file, fileName }) => {
  const user = getUserDetails();

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=uploadFuntionZipFile&companyid=${user.companyid}&fileName=${fileName}`,
    file,
    {
      headers: {
        "content-type": file.type,
      },
    },
  );
  return response.data;
};

const useUploadCustomFunctionFile = (options = {}) => {
  return useMutation({
    mutationFn: ({ file, fileName }) => uploadCustomFunctionFile({ file, fileName }),
    ...options,
  });
};

const getCustomFunctionScripts = async () => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getListofScriptsFunction&companyid=${user.companyid}`,
  );

  return response.data;
};

const useGetCustomFunctionScripts = (options = {}) => {
  return useQuery({
    queryKey: ["customFunctionScripts"],
    queryFn: () => getCustomFunctionScripts(),
    ...options,
  });
};

const deleteCustomFunctionFiles = async (files, productId) => {
  const user = getUserDetails();

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteProductFile&companyid=${user.companyid}&productId=${productId}`,
    files,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  return response;
};

const useDeleteCustomFunctionFiles = (options = {}) => {
  return useMutation({
    mutationFn: ({ files, productId }) => deleteCustomFunctionFiles(files, productId),
    ...options,
  });
};

export { useUploadCustomFunctionFile, useGetCustomFunctionScripts, useDeleteCustomFunctionFiles };
